(() => {
  'use strict';
  const TF = window.Nbloop;
  if (!TF || TF.product) return;
  TF.product = true;
  const requests = new Map();
  const showMedia = (root, id) => {
    const target = root.querySelector(`[data-media-id="${CSS.escape(String(id))}"]`);
    const track = root.querySelector('.nl-gallery-track');
    if (!target || !track) return;
    track.scrollTo({ left:target.offsetLeft - track.firstElementChild.offsetLeft, behavior:'instant' });
    root.querySelectorAll('[data-media-target]').forEach(el => el.setAttribute('aria-current', String(el.dataset.mediaTarget === String(id))));
  };
  document.addEventListener('change', async event => {
    const input = event.target.closest('[data-option-id]');
    if (!input) return;
    const root = input.closest('[data-product-section]');
    if (!root) return;
    const productURL = input.dataset.optionProduct;
    if (productURL && new URL(productURL, location.origin).pathname !== root.dataset.productUrl) { location.assign(productURL); return; }
    const id = root.dataset.productSection;
    requests.get(id)?.abort();
    const controller = new AbortController(); requests.set(id, controller);
    const optionIds = [...root.querySelectorAll('[data-option-id]:checked')].map(el => el.dataset.optionId);
    const url = new URL(root.dataset.productUrl, location.origin);
    url.searchParams.set('option_values', optionIds.join(','));
    url.searchParams.set('section_id', id);
    const focusId = input.id;
    const quantity = root.querySelector('input[name=quantity]')?.value;
    const plan = root.querySelector('[name=selling_plan]')?.value;
    const buttons = [...root.querySelectorAll('[data-product-submit],.nl-sticky-add button')];
    buttons.forEach(button => { if (!button.hasAttribute('data-variant-disabled')) button.dataset.variantDisabled = String(button.disabled); button.disabled = true; });
    root.setAttribute('aria-busy','true');
    root.querySelectorAll('.nl-product-form').forEach(form => { form.inert = true; });
    try {
      const response = await fetch(url, { signal:controller.signal });
      if (!response.ok) throw new Error('Could not load this option. Please try again.');
      const html = await response.text();
      if (controller.signal.aborted) return;
      const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-product-section]');
      if (!next) throw new Error('Could not load this option. Please refresh the page.');
      root.replaceWith(next);
      const qty = next.querySelector('input[name=quantity]');
      if (qty && quantity) { qty.value = quantity; if (!qty.checkValidity()) qty.value = qty.min || '1'; }
      const planSelect = next.querySelector('[name=selling_plan]');
      if (planSelect && [...planSelect.options].some(option => option.value === plan)) planSelect.value = plan;
      const canonical = new URL(location.href);
      canonical.searchParams.delete('option_values');
      if (next.dataset.variantId) canonical.searchParams.set('variant', next.dataset.variantId);
      else { canonical.searchParams.delete('variant'); canonical.searchParams.set('option_values', optionIds.join(',')); }
      history.replaceState({}, '', canonical);
      document.getElementById(focusId)?.focus({ preventScroll:true });
      showMedia(next, next.dataset.featuredMedia);
      TF.init(next);
      window.Shopify?.PaymentButton?.init();
      TF.say('Product options updated.');
    } catch (error) {
      if (error.name !== 'AbortError') {
        const message = root.querySelector('[data-product-error]');
        if (message) message.textContent = error.message;
        /* Keep purchasing disabled: the selected options have not been verified. */
      }
    } finally { if (requests.get(id) === controller) { requests.delete(id); root.removeAttribute('aria-busy'); } }
  });
  document.addEventListener('click', async event => {
    const thumb = event.target.closest('[data-media-target]');
    if (thumb) { event.preventDefault(); showMedia(thumb.closest('[data-gallery]'), thumb.dataset.mediaTarget); }
    const zoom = event.target.closest('[data-zoom]');
    if (zoom && typeof HTMLDialogElement !== 'undefined') {
      event.preventDefault();
      let dialog = document.getElementById('nl-zoom');
      if (!dialog) {
        dialog = document.createElement('dialog'); dialog.id='nl-zoom'; dialog.className='nl-zoom-dialog'; dialog.setAttribute('aria-label','Enlarged product image');
        const close = document.createElement('button'); close.className='nl-icon-button'; close.type='button'; close.dataset.dialogClose=''; close.setAttribute('aria-label','Close enlarged image'); close.textContent='×';
        const img = document.createElement('img'); img.className='nl-zoom-image';
        dialog.append(close,img); document.body.append(dialog);
      }
      const img = dialog.querySelector('img'); img.src=zoom.href; img.alt=zoom.querySelector('img')?.alt || 'Product detail';
      TF.openDialog(dialog,zoom);
    }
    const share = event.target.closest('[data-share]');
    if (share) {
      const status = share.parentElement.querySelector('[data-share-status]');
      try {
        if (navigator.share) await navigator.share({ title:document.title,url:location.href });
        else { await navigator.clipboard.writeText(location.href); if(status) status.textContent='Product link copied.'; }
      } catch(error) { if (status && error.name !== 'AbortError') { status.classList.remove('nl-sr'); status.textContent=`Copy this link: ${location.href}`; } }
    }
  });
  const init = (scope=document) => {
    scope.querySelectorAll('[data-product-section]').forEach(root => showMedia(root,root.dataset.featuredMedia));
    scope.querySelectorAll('[data-recommendations]').forEach(el => {
      if (el.dataset.loaded) return; el.dataset.loaded='true';
      const load = async () => {
        try {
          const response = await fetch(el.dataset.url);
          if (!response.ok) return;
          const next = new DOMParser().parseFromString(await response.text(),'text/html').querySelector('[data-recommendations]');
          if (next?.querySelector('.nl-product-card')) { el.replaceChildren(...next.childNodes); TF.init(el); }
          else if (!window.Shopify?.designMode) el.hidden=true;
        } catch { if (!window.Shopify?.designMode) el.hidden=true; }
      };
      if ('IntersectionObserver' in window) { const observer=new IntersectionObserver(entries => { if(entries.some(e=>e.isIntersecting)){observer.disconnect();load();} },{rootMargin:'300px'});observer.observe(el); }
      else load();
    });
  };
  document.addEventListener('shopify:section:load', event=>init(event.target));
  addEventListener('pageshow',()=>init());
  init();
})();
